import { AitRowGroupData } from "./AitRowGroupData";
import { trDuplicate } from "./trDuplicate";

/**
 * Duplicate a row group in the body data by inserting a deep-cloned copy
 * immediately after the original at index `rgi + 1`.
 *
 * If `bodyData[rgi]` is undefined or `bodyData.length >= newLength` the
 * original `bodyData` is returned unchanged.
 *
 * @template T - Row/cell payload type
 * @param bodyData - Array of body row groups
 * @param rgi - Index of the row group to duplicate
 * @param newLength - Desired minimum length after duplication
 * @returns Updated array of `AitRowGroupData<T>` with the duplicated group inserted when applicable
 */
export const trDuplicateRowGroup = <T>(
  bodyData: AitRowGroupData<T>[],
  rgi: number,
  newLength: number,
): AitRowGroupData<T>[] => {
  return bodyData[rgi] === undefined || bodyData.length >= newLength
    ? bodyData
    : [...bodyData.slice(0, rgi + 1), trDuplicate(bodyData[rgi]), ...bodyData.slice(rgi + 1)];
};
